import { Component, computed, inject, input, output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { RouterLink } from '@angular/router';
import { ENVIRONMENT } from '../../../../../environments/environment.interface';
import { User } from '../../../../api/app-types/user.app';
import { Workplace } from '../../../../api/app-types/workplace.app';
import { Paginator } from '../../../../core/components/paginator/paginator';
import { PaginatedResponse } from '../../../../shared/pagination/paginated-response';
import { WorkplaceAccordion } from '../workplace-accordion/workplace-accordion';

@Component({
	selector: 'lvr-workplace-list',
	imports: [WorkplaceAccordion, Paginator, RouterLink],
	templateUrl: './workplace-list.html',
	styleUrl: './workplace-list.scss',
})
export class WorkplaceList {
	private readonly env = inject(ENVIRONMENT);
	public readonly institutionId = input.required<number | undefined>();
	public readonly institutionName = input<string>('');
	public readonly user = input.required<User>();
	public readonly page = input<PaginatedResponse<Workplace>>();
	public readonly workplaces = computed(() => this.page()?.entities ?? []);
	public readonly visibleWorkplaces = computed(() =>
		this.workplaces().filter((workplace) => !workplace.isMainInstitution),
	);
	public readonly totalItems = computed(() => {
		const total = this.page()?.totalEntities ?? 0;
		const hiddenCount = this.workplaces().length - this.visibleWorkplaces().length;
		return Math.max(0, total - hiddenCount);
	});

	public readonly pageIndex = computed(() => this.page()?.offset ?? 0);
	public readonly pageSize = computed(() => this.page()?.range ?? this.env.pagination.range);

	public readonly showFirstLastButtons = true;
	public readonly hidePageSize = false;

	public readonly pageRequested = output<{ pageIndex: number; pageSize: number }>();

	public handlePageEvent(event: PageEvent) {
		this.pageRequested.emit({ pageIndex: event.pageIndex, pageSize: event.pageSize });
	}

	public readonly workplacesAreEmpty = computed(() => {
		const workplace = this.visibleWorkplaces();
		if (!workplace || workplace.length === 0) {
			return true;
		} else {
			return false;
		}
	});
}
